import {
  STORE_DETAILS_FETCH_REQUEST,
  STORE_DETAILS_FETCH_SUCCESS,
  STORE_DETAILS_FETCH_FAILURE,
  UPDATE_FOLLOW_STATUS
} from "./actionTypes"

const INIT_STATE = {
  stores: {},       // storeId → { profile, topicIds: [], levelData }
  loading: false,
  error: null,
}

const storeDetailsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STORE_DETAILS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case STORE_DETAILS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        stores: {
          ...state.stores,
          [action.storeId]: action.payload
        }
      };
    case STORE_DETAILS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.error };

    case UPDATE_FOLLOW_STATUS: {
      const { storeId, isFollowing, followerCount } = action.payload;
      const store = state.stores[storeId];

      if (!store) return state;

      return {
        ...state,
        stores: {
          ...state.stores,
          [storeId]: {
            ...store,
            profile: {
              ...store.profile,
              isFollowing,
              followerCount,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};

export default storeDetailsReducer;




